import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import "../assets/jsx/WelcomeStyle.css";
import "../assets/jsx/ApplicationForm.css";
import { useLocation, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CssBaseline, Grid, Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FlyLogo from "../assets/images/flyhi_logo_full.svg";
import signUPImage from "../assets/images/signUP.svg";
import CStepper from "../components/utils/CStepper";
import CMenu from "../components/utils/CMenu";
import { getDropDownData } from "../actions/getDropDownData";
import MobileViewHeader from "../components/header/MobileViewHeader";
import PANValidationAndAdditionalAddressPage from "../components/forms/PANAndAdditionalAddressPage";
import { getUserData } from "../actions/getUserData";
import CircularLoader from "../components/utils/CircularLoader";
import {
  getPANStatus,
  verifyPANOnGrid,
} from "../services/authenticationService";
import { set } from "date-fns";
import { saveFormPath } from "../services/userService";
import { setAppLoader } from "../actions/setAppLoader";
import { useAuth } from '../context/AuthContext';

const PANValidationDetailsWrapper = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state?.getUserData?.data);
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const stepNumber = useSelector((state) => state?.getStep?.step);
  const [stepperCount, setStepperCount] = React.useState(4);
  const [hasLoaded, setHasLoaded] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(location.state?.tabValue);
  const { token: jwt } = useAuth();
  let userDetailId = localStorage.getItem("detailId");
  const [step, setStep] = React.useState();

  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const term = queryParams.get("step");
    setStep(+term);
  }, [location]);

  React.useEffect(() => {
    if (jwt) dispatch(getDropDownData());
  }, [jwt]);

  React.useEffect(() => {
    dispatch(getUserData(userDetailId));
  }, []);

  React.useEffect(
    () => async () => {
      dispatch(setAppLoader(true));
      if (!(userDetails?.user?.id)) {
        return;
      }

      await getPANStatus(userDetails?.user?.id).then(async (apiData) => {
        console.log("verifyPANOnGrid>>>", apiData);
        const data = apiData?.data;
        if (data?.response) {
          saveFormPath("/personalDetails", userDetails?.detailId);
          navigate("/personalDetails", {
            state: {
              tabValue: tabValue + 1,
              stepperCount: tabValue + 1,
              userDetailId: userDetailId,
            },
          });
          dispatch(setAppLoader(false));
        } else {
          setHasLoaded(true);
          dispatch(setAppLoader(false));
        }
      });
    },
    [userDetails]
  );

  function returnHome() {
    // localStorage.clear()
    // navigate('/')
  }

  return (
    <div style={{ height: "auto" }}>
      {/* <CAlert /> */}
      <AppBar
        sx={{ backgroundColor: theme.palette.headerColor }}
        position="static"
      >
        {matches ? (
          <Container maxWidth="xl">
            <Toolbar
              sx={{
                display: "grid",
                gridAutoFlow: "column",
                justifyContent: "space-between",
              }}
              disableGutters
            >
              <img
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  width: "50px",
                  height: "50px",
                  width: "50px",
                  height: "50px",
                }}
                src={FlyLogo}
                alt="logo"
              />
              <div
                sx={{
                  pt: 6,
                  gridColumn: "3 / 5",
                  display: { xs: "none", md: "block", lg: "none" },
                }}
              >
                <CStepper tabValue={stepperCount} />
              </div>
              <div
                onClick={returnHome}
                sx={{
                  gridColumn: "4 / 5",
                  textAlign: "left",
                  fontFamily: "lato",
                  cursor: "pointer",
                }}
                variant="body1"
              >
                <CMenu />
              </div>
            </Toolbar>
          </Container>
        ) : (
          <MobileViewHeader
            stepperCount={5}
            header="Aadhar Output"
            nextHeader="Bank Statement"
          />
        )}
      </AppBar>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />

        <Grid item xs={12} sm={6} md={6} component={Paper}>
          {hasLoaded ? (
            <PANValidationAndAdditionalAddressPage
              setTabValue={setTabValue}
              setStepperCount={setStepperCount}
              userId={userDetails?.user?.id}
            />
          ) : (
            <Grid
              item
              style={{
                minHeight: "80vh",
                display: "flex",
                justifyContent: "center", // horizontal center
                alignItems: "center", // vertical center
              }}
            >
              <Typography variant="body2">Checking Details...</Typography>
            </Grid>
          )}
        </Grid>
        <Grid
          item
          display={{ xs: "none", lg: "block", sm: "block" }}
          sm={6}
          md={6}
          sx={{
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <img src={signUPImage} alt="signup" />
        </Grid>
      </Grid>
    </div>
  );
};
export default PANValidationDetailsWrapper;
